<template>
    <div :id="'carouselCaptions' + data.code" class="carousel carousel-dark slide" data-bs-touch="false"
        data-bs-ride="false">
        <div v-if="data.photos.length > 0" class="carousel-indicators">
            <button type="button" :data-bs-target="'#carouselCaptions' + data.code" data-bs-slide-to="0" class="active"
                aria-current="true" :aria-label="'Slide ' + 0" @click.prevent="goToIndex(data, 0)"></button>
            <button v-for="(_photo, index) in data.photos" :key="index" type="button"
                :data-bs-target="'#carouselCaptions' + data.code" :data-bs-slide-to="index + 1"
                :aria-label="'Slide ' + index + 1" @click.prevent="goToIndex(data, index + 1)"></button>
        </div>
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class="d-flex flex-column" :class="data.photos.length > 0 ? 'pb-5' : ''">
                    <table>
                        <tr v-for="(experience, index) in data['experience_' + selectedLocale]" :key="index">
                            <td class="pb-2 pt-1 pe-1 pe-sm-3 d-flex align-items-start">
                                <small class="text-dark">
                                    •
                                </small>
                            </td>
                            <td class="pb-2">
                                <small class="text-dark">
                                    {{ experience }}
                                </small>
                            </td>
                        </tr>
                    </table>
                    <div class="w-100 py-3 mx-0 row g-3 d-flex justify-content-center">
                        <div v-for="(skill, index) in data.skills" :key="index"
                            class="col-3 col-md-2 col-lg-1 d-flex justify-content-center align-items-center">
                            <div :tooltip="skill.name" style="width: fit-content;">
                                <font-awesome-icon v-if="skill.icon_type == 'icon'" :icon="skill.icon"
                                    class="text-dark icon-tools" @click="openUrl(skill.url)" />
                                <img v-else :src="skill.icon" class="photo-tools" @click="openUrl(skill.url)" />
                            </div>
                        </div>
                    </div>
                    <div v-if="data.photos.length > 0" class="mt-3 d-flex flex-row justify-content-center">
                        <button type="button" @click.prevent="prevIndex(data)"
                            :data-bs-target="'#carouselCaptions' + data.code" data-bs-slide="prev"
                            class="btn btn-sm btn-outline-dark btn-left py-1 px-4">
                            <font-awesome-icon :icon="['fas', 'chevron-left']" />
                        </button>
                        <button type="button" disabled class="btn btn-sm btn-outline-dark btn-middle py-2 px-3">
                            <small class="fw-bold">{{ data.index_photo + 1 }}
                                / {{ data.photos.length + 1 }}</small>
                        </button>
                        <button type="button" @click.prevent="nextIndex(data)"
                            :data-bs-target="'#carouselCaptions' + data.code" data-bs-slide="next"
                            class="btn btn-sm btn-outline-dark btn-right py-2 px-4">
                            <font-awesome-icon :icon="['fas', 'chevron-right']" />
                        </button>
                    </div>
                </div>
            </div>
            <div v-for="(photo, index) in data.photos" :key="index"
                :class="index + 1 == data.index_photo ? 'carousel-item active' : 'carousel-item'">
                <div class="d-flex flex-column pb-5">
                    <div class="d-flex justify-content-center">
                        <img v-if="!photo.type.includes('video')" :src="photo.url" class="data-exp" :class="photo.type" />
                        <video v-else :width="photo.type === 'video_portrait' ? '360' : '640'" :height="photo.type === 'video_portrait' ? '640' : '360'" controls>
                            <source :src="photo.url" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div class="my-3 d-flex justify-content-center text-center">
                        <small v-if="photo['caption_' + selectedLocale] && photo['caption_' + selectedLocale] != ''" class="text-dark fw-bold">
                            <a v-if="photo.caption_url" :href="photo.caption_url" target="_blank">
                                {{ photo['caption_' + selectedLocale] }}
                            </a>
                            <template v-else>
                                {{ photo['caption_' + selectedLocale] }}
                            </template>
                        </small>
                    </div>
                    <div v-if="data.photos.length > 0" class="mt-3 d-flex flex-row justify-content-center">
                        <button type="button" @click.prevent="prevIndex(data)"
                            :data-bs-target="'#carouselCaptions' + data.code" data-bs-slide="prev"
                            class="btn btn-sm btn-outline-dark btn-left py-1 px-4">
                            <font-awesome-icon :icon="['fas', 'chevron-left']" />
                        </button>
                        <button type="button" disabled class="btn btn-sm btn-outline-dark btn-middle py-2 px-3">
                            <small class="fw-bold">{{ data.index_photo + 1 }}
                                / {{ data.photos.length + 1 }}</small>
                        </button>
                        <button type="button" @click.prevent="nextIndex(data)"
                            :data-bs-target="'#carouselCaptions' + data.code" data-bs-slide="next"
                            class="btn btn-sm btn-outline-dark btn-right py-2 px-4">
                            <font-awesome-icon :icon="['fas', 'chevron-right']" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JobCarousel',
    data() {
        return {
            selectedLocale: localStorage.getItem('locale') ?? this.$i18n.locale,
        };
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        type: {
            type: String,
            default: 'data',
        },
    },
    components: {
        // 
    },
    // mounted() {
    //     //
    // },
    // beforeUnmount() {
    //     //
    // },
    methods: {
        nextIndex(job) {
            if (job.index_photo == job.photos.length) {
                job.index_photo = 0;
            } else {
                job.index_photo++;
            }
        },

        prevIndex(job) {
            if (job.index_photo == 0) {
                job.index_photo = job.photos.length;
            } else {
                job.index_photo--;
            }
        },

        goToIndex(job, index) {
            job.index_photo = index;
        },
    },
    created() {
        //
    },
};
</script>

<style scoped>
.btn-left {
    border-radius: 50rem 0 0 50rem !important;
}

.btn-middle {
    border-left: none !important;
    border-right: none !important;
    border-radius: 0 !important;
}

.btn-right {
    border-radius: 0 50rem 50rem 0 !important;
}

.data-exp {
    max-height: 400px;
    width: auto;
    max-width: 100%;
    border: 2px solid #000;
    border-radius: 1rem;
    padding: 0.5rem;
}
</style>